import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusBadge, scoreTextClass } from 'components/ui/status-badge';
import { cn } from 'lib/utils';
import type { IEntity } from 'modules/result/types';

type Attempt = IEntity.Result;

/** A finished attempt reads as passed / not passed when the test has a pass mark. */
export function AttemptBadge({ attempt }: { attempt: Attempt }) {
  const { t } = useTranslation();
  if (attempt.status === 'in_progress') return <StatusBadge tone="warning">{t('in_progress')}</StatusBadge>;
  if (attempt.status === 'abandoned') return <StatusBadge tone="neutral">{t('abandoned')}</StatusBadge>;
  if (attempt.passed == null) return <StatusBadge tone="done">{t('completed')}</StatusBadge>;
  return attempt.passed ? (
    <StatusBadge tone="success">{t('passed')}</StatusBadge>
  ) : (
    <StatusBadge tone="error">{t('not_passed')}</StatusBadge>
  );
}

/** The score in its band colour; an attempt that isn't finished shows a dash. */
export function AttemptScore({ attempt, className }: { attempt: Attempt; className?: string }) {
  if (attempt.status !== 'completed') return <span className="text-muted-foreground/60">—</span>;
  return (
    <span className={cn('font-semibold tabular-nums', scoreTextClass(attempt.percentage), className)}>
      {Math.round(attempt.percentage)}%
    </span>
  );
}
